import { IExportPlugin, PluginType } from '@/version-types';
import { InstanceData, InstanceDataType } from '../data';
import { History } from './history';

export * from './history';
export * from './type';
export * from './track-func';

export const frameworkHistoryPlugin: IExportPlugin = {
    sort: 0,
    type: PluginType.EXTENSION,
    name: 'framework-history',
};

export function createHistory(identity: string) {
    const history = new History(identity);
    InstanceData.setData(identity, InstanceDataType.History, history);
    return history;
}

export function HistoryAPI(identity: string) {
    return InstanceData.getData(identity, InstanceDataType.History) as History;
}

export type IHistory = ReturnType<typeof HistoryAPI>;
